import ProducManagement from '@/modules/health-consulting-management/product-management';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import ProductManagementCreateForm from '../../components/forms/product-management/create.form';
import  ProductSliderEdit  from '../../components/forms/product-management/edit.form';

export default function ProductSlider() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <ProductManagementCreateForm />;
      case PermissionMode.EDIT:
        return <ProductSliderEdit />;
      default:
        return <ProducManagement />;
    }
  };
  return <>{renderContent()}</>;
}
